module.exports = __webpack_public_path__ + "img/Layer 11.2658aa0c.svg";